import { useEffect } from 'react';
import { usePageTitleStore } from '@/store/pageTitleStore';

/**
 * Gives the current page its own document title — already translated, without the tenant name,
 * which DocumentTitle appends — instead of its route's default (app/router/DocumentTitle.tsx).
 * Empty values keep the default; the title is dropped when the page unmounts.
 */
export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    usePageTitleStore.setState({ title });
    return () => {
      if (usePageTitleStore.getState().title === title) usePageTitleStore.setState({ title: null });
    };
  }, [title]);
}
